/* DolksMan — interactividad propia (vanilla, sin librerías) */
(function () {
  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.dk-reveal:not(.dk-visible)');
    if (!els.length) return;
    if (reducir || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dk-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dk-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-dk-contar]:not([data-dk-hecho])');
    if (!nums.length) return;
    function animar(el) {
      el.setAttribute('data-dk-hecho', '');
      var fin = parseFloat(el.getAttribute('data-dk-contar')) || 0;
      if (reducir) { el.textContent = fin; return; }
      var dur = 1600, t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(fin * e);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(animar); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-dk-parallax]');
    if (!imgs.length || reducir) return;
    var ticking = false;
    function actualizar() {
      imgs.forEach(function (img) {
        var f = parseFloat(img.getAttribute('data-dk-parallax')) || 0;
        var r = img.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * f * -0.01;
        img.style.setProperty('--dk-parallax', off.toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(actualizar); ticking = true; }
    }, { passive: true });
    actualizar();
  }

  function initGaleria() {
    document.querySelectorAll('[data-dk-galeria]').forEach(function (g) {
      if (g.hasAttribute('data-dk-listo')) return;
      g.setAttribute('data-dk-listo', '');
      var principal = g.querySelector('[data-dk-principal]');
      g.querySelectorAll('[data-dk-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.src = btn.getAttribute('data-dk-src');
          principal.alt = btn.getAttribute('data-dk-alt') || '';
          g.querySelectorAll('[data-dk-mini]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
          btn.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  function formatoPrecio(centimos, formato) {
    var n = (centimos / 100).toFixed(2);
    var partes = n.split('.');
    var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var conComa = miles + ',' + partes[1];
    var sinDec = miles;
    return (formato || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, sinDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0])
      .replace(/\{\{\s*amount\s*\}\}/, (centimos / 100).toFixed(2));
  }

  function initProducto() {
    document.querySelectorAll('[data-dk-producto]').forEach(function (root) {
      if (root.hasAttribute('data-dk-listo')) return;
      root.setAttribute('data-dk-listo', '');
      var datosEl = root.querySelector('[data-dk-variantes]');
      var form = root.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var inputId = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-dk-anadir]');
      var precio = root.querySelector('[data-dk-precio]');
      var antes = root.querySelector('[data-dk-antes]');
      var formato = root.getAttribute('data-dk-formato');
      var txtAgotado = root.getAttribute('data-dk-agotado');
      var txtBoton = btn ? btn.getAttribute('data-dk-texto') : '';

      // Cantidad
      var cant = root.querySelector('[data-dk-cantidad]');
      if (cant) {
        root.querySelectorAll('[data-dk-cant]').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = parseInt(cant.value, 10) || 1;
            v += parseInt(b.getAttribute('data-dk-cant'), 10);
            cant.value = Math.max(1, v);
          });
        });
      }

      // Variantes
      if (datosEl) {
        var variantes = JSON.parse(datosEl.textContent);
        root.querySelectorAll('[data-dk-opcion]').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var sel = [];
            root.querySelectorAll('[data-dk-grupo]').forEach(function (grupo) {
              var marcado = grupo.querySelector('input:checked');
              sel.push(marcado ? marcado.value : null);
            });
            var v = variantes.find(function (x) {
              return x.options.every(function (o, i) { return o === sel[i]; });
            });
            if (!v) {
              if (btn) { btn.disabled = true; btn.querySelector('[data-dk-btn-txt]').textContent = txtAgotado; }
              return;
            }
            inputId.value = v.id;
            if (precio) precio.textContent = formatoPrecio(v.price, formato);
            if (antes) {
              if (v.compare_at_price && v.compare_at_price > v.price) {
                antes.textContent = formatoPrecio(v.compare_at_price, formato);
                antes.hidden = false;
              } else { antes.hidden = true; }
            }
            if (btn) {
              btn.disabled = !v.available;
              btn.querySelector('[data-dk-btn-txt]').textContent = v.available ? txtBoton : txtAgotado;
            }
            if (v.featured_image) {
              var principal = root.querySelector('[data-dk-principal]');
              if (principal) principal.src = v.featured_image.src;
            }
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          });
        });
      }
    });
  }

  function initBarra() {
    var barra = document.querySelector('[data-dk-barra]');
    var ancla = document.querySelector('[data-dk-anadir]');
    if (!barra || !ancla || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (e) {
      var fuera = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      barra.classList.toggle('dk-barra--on', fuera);
    });
    io.observe(ancla);
    var btn = barra.querySelector('button');
    if (btn) btn.addEventListener('click', function () { ancla.click(); });
  }

  function initTodo() {
    initReveal(); initCifras(); initParallax(); initGaleria(); initProducto(); initBarra();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  // Editor de Shopify: re-inicializar al añadir/editar secciones
  document.addEventListener('shopify:section:load', initTodo);
})();
